module.exports = __webpack_public_path__ + "static/img/2-4.10d850f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/2-4.png
// module id = TXnF
// module chunks = 0